import { WhiteLabelData } from 'reactApp/modules/WhiteLabelModule/WhiteLabelModule.types';

const greenatom: WhiteLabelData = {
    billing_settings: {
        available_payment_methods: [],
        enabled: true,
    },
    partner_services: [],
    support_contacts: {
        email: '1111@greenatom.ru',
        question_form_url: '',
        phone: '1111',
    },
    available_services: [
        'bigdata',
        'containers',
        'databases',
        'gpu',
        'hotbox',
        'infra',
        'vision',
        'marketplace',
    ],
    tag: 'greenatom',
    ui_settings: {
        page_title: 'Greenatom',
        theme: 'Greenatom',
        hide_external_links: true,
        hide_access_control: true,
        hide_project_creation: true,
    },
    isExtIpDisabled: true,
    selectOnlyNetworks: true,
    createEntitiesInAnyNetworks: true,
    createEntitiesInNetworksWithoutInternet: true,
};

const helpLinkX5 = 'https://wiki.x5.ru/display/X5CLOUD';
const X5: WhiteLabelData = {
    billing_settings: {
        enabled: true,
        available_payment_methods: [],
    },
    available_services: ['containers', 'databases', 'infra', 'marketplace'],
    partner_services: [
        {
            title: 'Портал дополнительных сервисов',
            url: 'https://xcloud-services.x5.ru/',
            icon: 'file',
        },
        {
            title: 'Документация',
            url: helpLinkX5,
            icon: 'file',
        },
    ],
    networksCreationDisabled: true,
    networksRemovingDisabled: true,
    createEntitiesInAnyNetworks: true,
    routersHidden: true,
    cidr: '100.127.0.0/24',
    ui_settings: {
        page_title: 'X5 CLOUD',
        main_page_header: 'X5 CLOUD',
        theme: 'X5',
        hide_mcs_help: true,
    },
    support_contacts: {
        support_link: 'https://support.x5.ru/newApplication/1000793',
        help_link: helpLinkX5,
        question_form_url: helpLinkX5,
        email: 'x5cloud-support@x5.ru',
    },
    marketplace: {
        url: '/marketplace_templates',
    },
    defaultDnsDomain: 'x5.ru',
    needToAddVmSuffix: true,
    privateDnsEnabled: true,
    shownDnsWithExtNet: true,
    isHiddenEditingDnsName: true,
    dnsNameUniqueness: true,
    dnsNameMaxLength: 8,
    dnsDbNameMaxLength: 6,
    dnsClusterNameMaxLength: 6,
    isExtIpDisabled: true,
    magnumApiVersion: '1.8',
    isEditOnlyFirewall: true,
    isHiddenEditingPort: true,
    isHiddenRenamingServer: true,
    servers: {
        isHiddenSshKey: true,
    },
};

export const WhitelabelConfigs = {
    greenatom,
    X5,
};
